//
// Copyright (c) 2025 Comcast
//

// see https://github.com/haydenbleasel/tiptap-extension-jira/blob/main/src/extensions/subsup.ts
import { Mark, mergeAttributes } from '@tiptap/core'

const SubSup = Mark.create({
  name: 'subsup',

  addAttributes () {
    return {
      type: {
        default: 'sub',
        parseHTML: (element) => (element.tagName === 'SUB' ? 'sub' : 'sup'),
        renderHTML: (attributes) => {
          return { 'data-type': attributes.type }
        },
      },
    }
  },

  parseHTML () {
    return [
      { tag: 'sub', getAttrs: () => ({ type: 'sub' }) },
      { tag: 'sup', getAttrs: () => ({ type: 'sup' }) },
    ]
  },

  renderHTML ({ mark, HTMLAttributes }) {
    return [mark.attrs.type, mergeAttributes(HTMLAttributes), 0]
  },
})

export default SubSup
